'use client';
import _omit from 'lodash/omit';
import { useEffect } from 'react';
import isEqual from 'react-fast-compare';
import { useIsLowEndDeviceFromLocalStorage } from '../../../../../hooks/local-storage/useIsLowEndDeviceFromLocalStorage';
import { useUserRuntimeEnvDetails } from '../../../../../hooks/useUserContext';
import { useGetGlobalAppStateStoreState } from '../../../../../stores/app/GlobalAppStateStore';
import type { WebUserExtraContext } from '../../../../../stores/GlobalStateStore';
import { useSetDeviceContext } from '../helperHooks/useSetDeviceContext';

export function useSetDeviceAndBrowserDetails() {
  const { getGlobalAppStateStoreState } = useGetGlobalAppStateStoreState();
  const { setDeviceContext } = useSetDeviceContext();
  const { context, isLoadingContext } = useUserRuntimeEnvDetails();
  const deviceAndBrowserDetails = context as WebUserExtraContext;
  const { value: isLowEndDeviceFromStorage } = useIsLowEndDeviceFromLocalStorage();

  useEffect(() => {
    const currentDeviceContext = getGlobalAppStateStoreState().deviceContext;

    if (!deviceAndBrowserDetails || isLoadingContext) {
      return;
    }
    const currentBrowser = currentDeviceContext.browser;
    const currentDeviceInfo = _omit(currentDeviceContext.deviceInfo, 'isLowEndDevice');

    if (
      isEqual(currentBrowser, deviceAndBrowserDetails.browser) &&
      isEqual(currentDeviceInfo, deviceAndBrowserDetails.device)
    ) {
      return;
    }

    // We need support these in login page. Hence we need to set them even if user details are undefined (the device write is independent of the user).
    setDeviceContext({
      browser: deviceAndBrowserDetails.browser,
      deviceInfo: {
        ...deviceAndBrowserDetails.device,
        isLowEndDevice:
          currentDeviceContext.deviceInfo?.isLowEndDevice ?? isLowEndDeviceFromStorage,
      },
    });
  }, [
    deviceAndBrowserDetails,
    getGlobalAppStateStoreState,
    isLoadingContext,
    isLowEndDeviceFromStorage,
    setDeviceContext,
  ]);
}
